/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { EntityId } from '../types/api/EntityId';
import { getRandomId } from '../utils/getRandomId';

export const ORGANIZATION_INVITATION_EVENT_KEY = 'organization_invitation_{{id}}';

export const LOGOUT_NOTICE_EVENT_KEY = 'LOGOUT_NOTICE_EVENT_KEY';

export const getOrganizationInvitationEventKey = (id: EntityId) =>
  ORGANIZATION_INVITATION_EVENT_KEY.replace('{{id}}', `${id}`);

export const getCommonEventKey = () => getRandomId();
export const getLogoutNoticeEventKey = () => LOGOUT_NOTICE_EVENT_KEY;
